import type { BuiltInRole } from '../types';
import { ACCOUNT_FEATURE_GROUP } from '../features/administrative/account';
import { NOTIFICATIONS_FEATURE_GROUP } from '../features/administrative/notifications';
import { PRODUCTS_FEATURES } from '../features/administrative/products';
import { RESOURCES_FEATURES } from '../features/administrative/resources';
import { CRM_INTEGRATIONS_FEATURE_GROUP } from '../features/crm-integrations';
import { PAYMENTS_FEATURE_GROUP } from '../features/payments';
import { CRM_FEATURE_GROUP } from '../features/crm';
import { TICKETS_FEATURE_GROUP } from '../features/tickets';
import { MARKETING_FEATURE_GROUP } from '../features/marketing';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../features/administrative';

export const BASIC_ACCESS: BuiltInRole = {
  guid: 'a1b2c3d4-5678-4def-9abc-def012345678',
  name: 'basic-access',
  description: 'Baseline permissions granted to every role by default',
  builtIn: true,
  roles: [],
  allow: [
    PRODUCTS_FEATURES.READ.guid,
    ACCOUNT_FEATURE_GROUP.guid,
    NOTIFICATIONS_FEATURE_GROUP.guid,
    RESOURCES_FEATURES.READ.guid,
  ],
};

export const USER: BuiltInRole = {
  guid: '3b6e41bb-570a-4287-9875-9f3be1a23420',
  name: 'user',
  description: 'Standard user with baseline access; inherits default product and account permissions',
  builtIn: true,
  roles: [BASIC_ACCESS.guid],
  allow: [],
};

export const ADMIN: BuiltInRole = {
  guid: '3325739e-716b-4267-a2cb-3dd7b6d82337',
  name: 'admin',
  description: 'Full access to all features and settings',
  builtIn: true,
  roles: [BASIC_ACCESS.guid],
  allow: [CRM_INTEGRATIONS_FEATURE_GROUP.guid, ADMINISTRATIVE_FEATURE_GROUP.guid, PAYMENTS_FEATURE_GROUP.guid, CRM_FEATURE_GROUP.guid, TICKETS_FEATURE_GROUP.guid, MARKETING_FEATURE_GROUP.guid],
  deny: [],
};

export const ALTRU_INTEGRATION: BuiltInRole = {
  guid: 'd4fed775-bd1f-421e-9e29-59ba69f4d0ff',
  name: 'altru-integration',
  description: 'Use every Altru integrations application; inherits default product and account permissions',
  builtIn: true,
  roles: [BASIC_ACCESS.guid],
  allow: [CRM_INTEGRATIONS_FEATURE_GROUP.guid],
  deny: [],
};

/**
 * All built-in roles, keyed by name.
 * Used by role-registry.ts to build the startup registry and by
 * resolve-features.ts to map stored role strings to GUIDs.
 */
export const BUILT_IN_ROLES = {
  BASIC_ACCESS,
  USER,
  ADMIN,
  ALTRU_INTEGRATION,
} as const satisfies Record<string, BuiltInRole>;
